import type { VexalynConfig } from '@vexalyn/config';

type LogLevel = VexalynConfig['logLevel'];
const priority: Record<LogLevel, number> = { debug: 10, info: 20, warn: 30, error: 40 };

export interface Logger {
  debug(message: string, data?: unknown): void;
  info(message: string, data?: unknown): void;
  warn(message: string, data?: unknown): void;
  error(message: string, data?: unknown): void;
}

export function createLogger(level: LogLevel = 'info'): Logger {
  const write = (entryLevel: LogLevel, message: string, data?: unknown): void => {
    if (priority[entryLevel] < priority[level]) return;
    const suffix = data === undefined ? '' : ` ${JSON.stringify(data)}`;
    console[entryLevel === 'debug' ? 'debug' : entryLevel](`[${entryLevel}] ${message}${suffix}`);
  };
  return {
    debug: (message, data) => write('debug', message, data),
    info: (message, data) => write('info', message, data),
    warn: (message, data) => write('warn', message, data),
    error: (message, data) => write('error', message, data),
  };
}
